module.exports = __webpack_public_path__ + "static/img/gg1.3ef4322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gg1.png
// module id = flxU
// module chunks = 1